/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Member {
    import fld = MbReport01_DtRow.Fields;
    @Serenity.Decorators.registerClass()
    export class MbReport01_DtEditor extends Serenity.Extensions.GridEditorBase<MbReport01_DtRow> {
        protected getColumnsKey() { return "Member.MbReport01_Dt"; }
        protected getDialogType() { return MbReport01_DtDialog; }
        protected getIdProperty() { return MbReport01_DtRow.idProperty; }
        protected getLocalTextPrefix() { return MbReport01_DtRow.localTextPrefix; }
        protected getService() { return MbReport01_DtService.baseUrl; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-30));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            // var q = Q.parseQueryString();
            // if (q["ShopId"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "ShopId");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["ShopId"];
            //     };
            // }


            return filters;
        }   

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
           

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('GrossSales'),
                    new Slick.Aggregators.Sum('AllItemDiscount'),
                    new Slick.Aggregators.Sum('AllItemCharge'),
                    new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('NetSalesExVat'),
                    new Slick.Aggregators.Sum('VatOfNetSales'),
                    new Slick.Aggregators.Sum('VatOfCharge')
                ]
            });
            return grid;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

